import { Box, Typography } from '@mui/material';
import type { BreadcrumbsItemProps } from './types';

type Props = {
  item: BreadcrumbsItemProps;
  action: (id: string) => void;
};

export function BreadcrumbsItem({ item, action }: Props) {
  const { name, id, icon } = item;

  const renderContent = (
    <>
      {icon && (
        <Box
          component="span"
          sx={{
            display: 'inherit',
            '& svg': { width: 16, height: 16, mr: 0.5 },
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="button">{name}</Typography>
    </>
  );

  return (
    <Box
      onClick={() => action(id || '')}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'text.primary',
        cursor: 'pointer',
      }}
    >
      {renderContent}
    </Box>
  );
}
